import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./DashboardHeadline.css";
import Icon from "components/library/Icon";
import withTooltip from "components/library/Tooltip/withTooltip";

export default function DashboardHeadline(props) {
  const IconWithTooltip = withTooltip(Icon);

  return (
    <div>
      <h2
        className={classNames(styles.headline, {
          [styles.noHeadline]: !props.headline,
        })}
      >
        {props.headline ? props.headline : "No headline"}
      </h2>
      {props.isPrivate ? (
        <IconWithTooltip
          name="private"
          className={styles.icon}
          tooltip="Private story"
        />
      ) : null}
    </div>
  );
}

DashboardHeadline.propTypes = {
  id: PropTypes.string.isRequired,
  headline: PropTypes.string,
  isPrivate: PropTypes.bool,
};
